module.exports = __webpack_public_path__ + "static/media/iconInstagramFooter.d7a125ce.svg";